import { render } from "./ShopifyLogoIcon.vue?vue&type=template&id=3a488c85"
import script from "./ShopifyLogoIcon.vue?vue&type=script&lang=js"
export * from "./ShopifyLogoIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/flydata-next/flydata-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__